/**
 * @generated SignedSource<<4a48cb72adf76032dd34d3e2431b6b4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type businessInitQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessInitQuery$data = {
  readonly getSurveyBusinessAnswer: {
    readonly businessAnswer: ReadonlyArray<{
      readonly bmanTin: string | null | undefined;
      readonly bsno: string | null | undefined;
      readonly isCompleted: boolean | null | undefined;
      readonly tnm: string | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessInitQuery = {
  response: businessInitQuery$data;
  variables: businessInitQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessAnswerOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessAnswer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessAnswer",
        "kind": "LinkedField",
        "name": "businessAnswer",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tnm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bsno",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bmanTin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isCompleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessInitQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessInitQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "d4b340bfe7a1bd89b198950aea5dec4d",
    "id": null,
    "metadata": {},
    "name": "businessInitQuery",
    "operationKind": "query",
    "text": "query businessInitQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessAnswer(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    businessAnswer {\n      tnm\n      bsno\n      bmanTin\n      isCompleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "402d8d668d851ab67be5b64b639a1956";

export default node;
